import { AbstractControlOptions, AsyncValidatorFn, UntypedFormControl, ValidatorFn } from '@angular/forms';
import { isArray, isFunction, isObject } from '@app/util';
import * as R from 'ramda';

const getValidators = (validatorOrOpts?: ValidatorFn | ValidatorFn[] | AbstractControlOptions | null) => {
  if (validatorOrOpts) {
    if (isArray(validatorOrOpts)) {
      return validatorOrOpts;
    } else if (isFunction(validatorOrOpts)) {
      return [validatorOrOpts];
    } else if (isObject(validatorOrOpts) && validatorOrOpts.validators) {
      return isArray(validatorOrOpts.validators) ? validatorOrOpts.validators : [validatorOrOpts.validators];
    }
  }

  return [];
};

/**
 * Extension of Angular's FormControl that allow dynamic adding of validators.
 */
export class PcsFormControl extends UntypedFormControl {
  private readonly pcsValidators: ValidatorFn[] = [];

  constructor(
    formState?: any,
    validatorOrOpts?: ValidatorFn | ValidatorFn[] | AbstractControlOptions | null,
    asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null
  ) {
    super(formState, validatorOrOpts, asyncValidator);
    this.pcsValidators = getValidators(validatorOrOpts);
  }

  addValidators(validators: ValidatorFn[]) {
    super.setValidators([...this.pcsValidators, ...validators]);
  }
}

export const isPcsFormControl = R.is(PcsFormControl);
